export default "__VITE_ASSET__Bf5hK7Jn__"